import type * as Types from '../../../../../shared/generated/graphql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type SendInvitationEmailMutationVariables = Types.Exact<{
  input: Types.SendInvitationEmailInput;
}>;

export type SendInvitationEmailMutation = {
  __typename?: 'Mutation';
  sendInvitationEmail: {
    __typename?: 'SendInvitationEmailResponse';
    message: string;
    success: boolean;
  };
};

export const SendInvitationEmailDocument = gql`
  mutation SendInvitationEmail($input: SendInvitationEmailInput!) {
    sendInvitationEmail(input: $input) {
      message
      success
    }
  }
`;
export type SendInvitationEmailMutationFn = Apollo.MutationFunction<
  SendInvitationEmailMutation,
  SendInvitationEmailMutationVariables
>;
export function useSendInvitationEmailMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SendInvitationEmailMutation,
    SendInvitationEmailMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SendInvitationEmailMutation,
    SendInvitationEmailMutationVariables
  >(SendInvitationEmailDocument, options);
}
export type SendInvitationEmailMutationHookResult = ReturnType<
  typeof useSendInvitationEmailMutation
>;
export type SendInvitationEmailMutationResult =
  Apollo.MutationResult<SendInvitationEmailMutation>;
export type SendInvitationEmailMutationOptions = Apollo.BaseMutationOptions<
  SendInvitationEmailMutation,
  SendInvitationEmailMutationVariables
>;
